import { render, staticRenderFns } from "./SystemConfigList.vue?vue&type=template&id=a4367c36&scoped=true"
import script from "./SystemConfigList.vue?vue&type=script&lang=js"
export * from "./SystemConfigList.vue?vue&type=script&lang=js"
import style0 from "./SystemConfigList.vue?vue&type=style&index=0&id=a4367c36&scoped=true&lang=css"
import style1 from "./SystemConfigList.vue?vue&type=style&index=1&id=a4367c36&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4367c36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4367c36')) {
      api.createRecord('a4367c36', component.options)
    } else {
      api.reload('a4367c36', component.options)
    }
    module.hot.accept("./SystemConfigList.vue?vue&type=template&id=a4367c36&scoped=true", function () {
      api.rerender('a4367c36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/SystemConfigList.vue"
export default component.exports